import { SxProps } from '@mui/material';

export const addToWishListSX: Record<string, SxProps> = {
	newDesignContainer: {
		display: 'flex',
		cursor: 'pointer',
		padding: '0 5px',
		borderRadius: '3px',
		'&:hover': {
			backgroundColor: 'grey.50',
		},
		'&:active': {
			backgroundColor: 'grey.50',
			color: 'primary.main',
			'> span': {
				color: 'text.main',
			},
		},
		flexDirection: 'column',
		gap: '2px',
		height: '40px',
		justifyContent: 'center',
	},
	wishListFillIcon: {
		color: 'primary.main',
	},
	wishListLabelSX: {
		color: 'grey.500',
		textAlign: 'center',
		fontSize: '12px',
		lineHeight: '1.2',
		fontWeight: 400,
		textTransform: 'none',
	},
	wishListTypographySX: {
		color: 'grey.500',
		fontSize: '16px',
		lineHeight: '1.5',
		fontWeight: 400,
		fontFamily: 'Inter, Arial, sans-serif',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	wishListIconButtonSX: {
		width: '40px',
		height: '40px',
		color: 'grey.500',
		borderRadius: '3px',
		'& .MuiSvgIcon-root': {
			fontSize: '20px',
		},
	},
	wishListInputSX: {
		flexGrow: 1,
		'& .MuiInputBase-root': {
			width: '100%',
			height: '40px',
			border: '1px solid',
			borderColor: 'grey.100',
			borderRadius: '3px',
			padding: '0 10px',
			backgroundColor: '#FFFFFF',
			fontSize: '16px',
			color: 'grey.500',
		},
		'& .MuiInputBase-input': {
			padding: '0',
		},
		'& .MuiInput-underline:before, & .MuiInput-underline:after': {
			display: 'none',
		},
	},
	emptyStateMenuItemSX: {
		padding: '10px',
		justifyContent: 'flex-start',
		pointerEvents: 'none',
		'& .MuiTypography-root': {
			color: 'grey.200',
			fontSize: '14px',
			textAlign: 'center',
		},
	},
	wishListCreateLinkSX: {
		color: 'secondary.main',
		fontSize: '16px',
		lineHeight: '1.5',
		fontWeight: 400,
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		cursor: 'pointer',
		width: '100%',
		'& .MuiSvgIcon-root': {
			color: 'secondary.main',
			fontSize: '20px',
		},
	},
	wishListItemBoxSX: {
		maxHeight: '140px',
		overflowY: 'auto',
		'&::-webkit-scrollbar': { width: '5px' },
		'&::-webkit-scrollbar-thumb': { backgroundColor: 'grey.100', borderRadius: '10px' },
	},
	wishListMenuItemSX: {
		padding: '10px',
		justifyContent: 'flex-start',
		backgroundColor: 'transparent',
		'&:hover': {
			backgroundColor: 'background.selectedStore',
		},
		'&.Mui-focusVisible': {
			backgroundColor: 'background.selectedStore',
		},
		'&:active': {
			backgroundColor: 'background.selectedStore',
		},
	},
};

export const addToWishListCartViewSX: Record<string, SxProps> = {
	button: {
		p: 0,
		height: 'auto',
		':hover': {
			backgroundColor: 'white',
		},
	},
	text: {
		':hover': {
			textDecoration: 'underline',
		},
	},
	color: {
		'& .MuiSvgIcon-root': {
			color: 'primary.main',
		},
	},
};

export const wishListMenuPaperSX = {
	elevation: 0,
	sx: {
		width: '280px',
		backgroundColor: '#FFFFFF',
		borderRadius: '3px',
		boxShadow: '0px 1px 3px 0px #000000',
		mt: '10px',
		'& .MuiList-root': {
			padding: 0,
			overflowY: 'auto',
		},
	},
};
export const wishListMenuPaperCartView = {
	elevation: 1,
	sx: {
		width: 'auto',
		backgroundColor: '#FFFFFF',
		borderRadius: '3px',
		mt: '10px',
		borderTop: '2px solid',
		borderColor: 'primary.main',
		'& .MuiList-root': {
			padding: 0,
			overflowY: 'auto',
		},
	},
};
